module.exports = __webpack_public_path__ + "img/Logo_nova.2053c848.png";